import * as angular from "angular";

angular
  .module('bringoz.admin.pricePlan')
  .filter('parentValue', parentValue);


function parentValue(splitService) {
  const dataTypeToSymbol = {
    Percent: '%',
    String: '',
    Minutes: 'Min',
    Price: splitService.getCurrencySymbol()
  };

  return function parentValueFilter(field, prefix) {
    const symbol = dataTypeToSymbol[field.dataType],
      parentValue = field.parentValue;

    return prefix ? symbol + '' + parentValue : parentValue + '' + symbol;
  }
}
